<template>
  <a-modal
    class="template-download-modal"
    :title="$t('TP_Download_1')"
    :visible="visible"
    :maskClosable="false"
    centered
    @cancel="handleCancel"
  >
    <!-- custom footer -->
    <template v-slot:footer>
      <a-button key="back" @click="handleCancel">{{$t("Common_Cancel")}}</a-button>
      <a-button
        key="submit"
        type="primary"
        :loading="loading"
        @click="handleOk"
      >
        {{$t("TP_Download_3")}}
      </a-button>
    </template>

    <!-- contents -->
    <div class="content-group">
      <div class="content-item">
        <div class="modal-title">HostName</div>
        <div class="modal-value">
          <input class="modal-input" type="text" v-model="hostName" />
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { toRefs, ref, reactive, computed } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import { apiUrl } from "@/utils/common";
import fileDownload from "js-file-download";

export default {
  name: "TemplateDownloadModal",
  props: {
    mode: String,
    visible: Boolean,
    templateInfo: Object,
    toggleModal: Function,
  },
  setup(props) {
    const store = useStore();
    const templateState = computed(() => store.getters["template/STATE"]);

    const state = reactive({
      loading: false,
      hostName: "",
    });

    const handleOk = async () => {
      state.loading = true;

      const params = {
        hostName: state.hostName,
        templateNoArray: templateState.value.selectedNoArray,
      };

      if (!!state.hostName) {
        try {
          const response = await axios({
            method: "post",
            headers: {
              "Content-Type": "application/octet-stream",
            },
            responseType: "arraybuffer",
            url: apiUrl + "Template/Download",
            data: params,
          });
          if (response && !response.data.error) {
            // store.dispatch("template/DOWNLOAD_TEMPLATE", response);
            fileDownload(response.data, "mudfix_template.zip");
          }
        } catch (error) {
          console.log("template download error", error);
        }
        props.toggleModal();
      }

      state.loading = false;
    };

    const handleCancel = () => {
      props.toggleModal();
    };

    return {
      ...toRefs(state),
      handleOk,
      handleCancel,
    };
  },
};
</script>